import SeasonMapper from './season-mapper';
import SportEventModel from '../sport-event/sport-event-model';
import MarketModel from '../market/market-model';

const SeasonModel = {
    mapper: SeasonMapper,

    categoryName: {
        type: String,
    },

    countryCode: {
        fieldName: 'u',
        type: String,
    },

    currentSeasonId: {
        type: String,
    },

    events: {
        model: SportEventModel,
        type: Array,
    },

    id: {
        fieldName: 'i',
        type: String,
    },

    order: {
        fieldName: 'o',
        type: Number,
    },

    seasonName: {
        type: String,
    },

    programCode: {
        type: String,
    },

    sportTypeRefId: {
        type: String,
    },

    year: {
        type: String,
    },

    mbn: {
        type: Number,
    },

    nextBetStopDate: {
        type: Number,
    },

    markets: {
        modelContext: {
            eventId: 'currentSeasonId',
        },
        model: MarketModel,
        type: Array,
    },
};

export default SeasonModel;
